export default class UserAlert {
    constructor(dto, title, description) {
        this.documentIds = [];
        this.alertIds = [];
        this.type = 0;
        this.contentTypeIds = [];
        this.contentTypeName = '';
        this.date = false;
        this.title = title;
        this.description = description;

        if (dto) {
            this.documentIds = dto.ObjectIDs
            this.alertIds = dto.AlertIDs
            this.contentTypeIds = dto.ContentTypeIDs
            this.type = dto.Type
            this.contentTypeName = dto.ContentTypeName
            this.date = dto.DateStr
        }
    }

    toDto() {
        return {
            ObjectIDs: this.documentIds,
            AlertIDs: this.alertIds,
            ContentTypeIDs: this.contentTypeIds,
            Type: this.type,
            ContentTypeName: this.contentTypeName,
            DateStr: this.date,
        }
    }
}
